export const ESTADOS = {
  Planificada:       { color: "#475569", bg: "#f1f5f9", label: "Planificada" },
  Avanzando:         { color: "#1e40af", bg: "#eff6ff", label: "Avanzando" },
  Terminada:         { color: "#166534", bg: "#f0fdf4", label: "Terminada" },
  Bloqueada:         { color: "#991b1b", bg: "#fef2f2", label: "Bloqueada" },
  "Esp. aprobación": { color: "#c2410c", bg: "#fff7ed", label: "Esp. aprobación" },
};

export const ORDEN_ESTADO = ["Bloqueada", "Esp. aprobación", "Avanzando", "Planificada", "Terminada"];
